import { TkSelectProps } from "../../type/componentsType/TkSelectForm";

// 都道府県
export enum Prefectures {
  "北海道" = "01",
  "青森県" = "02",
  "岩手県" = "03",
  "宮城県" = "04",
  "秋田県" = "05",
  "山形県" = "06",
  "福島県" = "07",
  "茨城県" = "08",
  "栃木県" = "09",
  "群馬県" = "10",
  "埼玉県" = "11",
  "千葉県" = "12",
  "東京都" = "13",
  "神奈川県" = "14",
  "新潟県" = "15",
  "富山県" = "16",
  "石川県" = "17",
  "福井県" = "18",
  "山梨県" = "19",
  "長野県" = "20",
  "岐阜県" = "21",
  "静岡県" = "22",
  "愛知県" = "23",
  "三重県" = "24",
  "滋賀県" = "25",
  "京都府" = "26",
  "大阪府" = "27",
  "兵庫県" = "28",
  "奈良県" = "29",
  "和歌山県" = "30",
  "鳥取県" = "31",
  "島根県" = "32",
  "岡山県" = "33",
  "広島県" = "34",
  "山口県" = "35",
  "徳島県" = "36",
  "香川県" = "37",
  "愛媛県" = "38",
  "高知県" = "39",
  "福岡県" = "40",
  "佐賀県" = "41",
  "長崎県" = "42",
  "熊本県" = "43",
  "大分県" = "44",
  "宮崎県" = "45",
  "鹿児島県" = "46",
  "沖縄県" = "47",
}

// 都道府県（地方から分類）
export const japanRegions = [
  {
    region: "北海道地方",
    prefectures: ["北海道"],
  },
  {
    region: "東北地方",
    prefectures: ["青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県"],
  },
  {
    region: "関東地方",
    prefectures: [
      "茨城県",
      "栃木県",
      "群馬県",
      "埼玉県",
      "千葉県",
      "東京都",
      "神奈川県",
    ],
  },
  {
    region: "中部地方",
    prefectures: [
      "新潟県",
      "富山県",
      "石川県",
      "福井県",
      "山梨県",
      "長野県",
      "岐阜県",
      "静岡県",
      "愛知県",
    ],
  },
  {
    region: "近畿地方",
    prefectures: [
      "三重県",
      "滋賀県",
      "京都府",
      "大阪府",
      "兵庫県",
      "奈良県",
      "和歌山県",
    ],
  },
  {
    region: "中国地方",
    prefectures: ["鳥取県", "島根県", "岡山県", "広島県", "山口県"],
  },
  {
    region: "四国地方",
    prefectures: ["徳島県", "香川県", "愛媛県", "高知県"],
  },
  {
    region: "九州・沖縄地方",
    prefectures: [
      "福岡県",
      "佐賀県",
      "長崎県",
      "熊本県",
      "大分県",
      "宮崎県",
      "鹿児島県",
      "沖縄県",
    ],
  },
];

// 経営者種別（申込用）
export enum CorpTypeList1 {
  "社会福祉法人" = "01",
  "社会福祉法人以外" = "99",
  "学校法人" = "08",
}

// 経営者種別（新規契約用）
export enum CorpTypeList2 {
  "社会福祉法人" = "01",
  "財団法人" = "02",
  "社団法人" = "03",
  "宗教法人" = "04",
  "個人（任意団体を含む）" = "05",
  "その他の法人" = "06",
  "医療法人" = "07",
  "学校法人" = "08",
  "特定非営利活動法人" = "09",
  "公益財団法人" = "10",
  "一般財団法人" = "11",
  "公益社団法人" = "12",
  "一般社団法人" = "13",
  "学校法人（認定こども園）" = "14",
}

// はい/いいえフラグ
export enum OkOrNoFlug {
  "はい" = "1",
  "いいえ" = "0",
}

// 共共・共給
export enum CommonOrCommonRetirementFlug {
  "共共" = "1",
  "共給" = "0",
}

// 有無フラグ
export enum YesOrNoFlug {
  "有" = "1",
  "無" = "0",
}

// 利用有無フラグ
export enum UseOrNot {
  "利用する" = "1",
  "利用しない" = "0",
}

// メールアドレスドメイン
export enum EmailDomains {
  "gmail.com" = "gmail.com",
  "yahoo.co.jp" = "yahoo.co.jp",
  "icloud.com" = "icloud.com",
  "hotmail.com" = "hotmail.com",
  "live.jp" = "live.jp",
  "outlook.com" = "outlook.com",
  "aol.jp" = "aol.jp",
  "docomo.ne.jp" = "docomo.ne.jp",
  "au.com" = "au.com",
  "ezweb.ne.jp" = "ezweb.ne.jp",
  "i.softbank.jp" = "i.softbank.jp",
  "softbank.ne.jp" = "softbank.ne.jp",
  "ymobile.ne.jp" = "ymobile.ne.jp",
  "rakuten.jp" = "rakuten.jp",
  "nifty.com" = "nifty.com",
  "ybb.ne.jp" = "ybb.ne.jp",
  "dream.jp" = "dream.jp",
  "Tigers-net.com" = "Tigers-net.com",
  "t-bb.jp" = "t-bb.jp",
}

// 性別フラグ
export enum SexFlug {
  "男" = "1",
  "女" = "2",
}

export enum MasQuitReasonList {
  "退職" = "1",
  "解除" = "2",
  "合算申出" = "3",
}

// 職種
export enum JobList {
  "施設長" = "01",
  "指導員" = "02",
  "保育士" = "03",
  "介護職員" = "04",
  "医師" = "05",
  "看護師" = "06",
  "訓練指導員" = "07",
  "栄養士" = "08",
  "調理員" = "09",
  "事務員" = "10",
  "介助員" = "11",
  "ホームヘルパー" = "12",
  "介護支援専門員" = "13",
  "その他" = "14",
}

// 加入/未加入フラグ
export enum AddInFlug {
  "加入" = "1",
  "未加入" = "0",
}

// 福祉医療機構以外からの退職金受け取りの有無
export enum OtherBenefitsFlg {
  "他の退職金の受け取り「有」" = "1",
  "他の退職金の受け取り「無」" = "0",
}

// 手当種別
export const AllowanceType = {
  "1": "特殊業務手当",
  "2": "給与特別改善手当",
  "3": "その他",
};

//　年度リスト
export const generateYearListForSearch = (): TkSelectProps[] => {
  const YearListForSearch: TkSelectProps[] = [];

  const startYear =
    (process.env.REACT_APP_START_YEAR_FOR_SEARCH as unknown as number) || 2025;
  let endYear = Number(new Date().getFullYear());
  endYear = endYear > startYear ? endYear : 2025;

  for (let i = startYear; i <= endYear; i++) {
    YearListForSearch.push({
      label: `${i}年度`,
      value: `${i}`,
    });
  }

  return YearListForSearch;
};

// 月リスト
export const generateMonthListForSearch = (): TkSelectProps[] => {
  const MonthListForSearch: TkSelectProps[] = [];

  for (let i = 1; i <= 12; i++) {
    MonthListForSearch.push({
      label: `${i}月`,
      value: `${i}`,
    });
  }

  return MonthListForSearch;
};

// 五十音図
export const hiragana = [
  ["わ", "", "", "", ""],
  ["ら", "り", "る", "れ", "ろ"],
  ["や", "", "ゆ", "", "よ"],
  ["ま", "み", "む", "め", "も"],
  ["は", "ひ", "ふ", "へ", "ほ"],
  ["な", "に", "ぬ", "ね", "の"],
  ["た", "ち", "つ", "て", "と"],
  ["さ", "し", "す", "せ", "そ"],
  ["か", "き", "く", "け", "こ"],
  ["あ", "い", "う", "え", "お"],
];

export const transposedHiragana = hiragana[0].map((_, i) =>
  hiragana.map((row) => row[i])
);

// 区分（請求ID選択ダイアログ部品）
export enum ContractType {
  ExistingContractCorporate = "既契約掛金（既契約法人)",
  NewContractCorporate = "既契約掛金（新規契約法人)",
  AdditionalChargeExisting = "割増金（既契約掛金)",
  MidwayChargeNewCorporate = "途中掛金（新規契約掛金法人)",
  AdditionalChargeMidway = "割増金（途中掛金)",
  MidwayChargeRetroactive = "途中掛金（遡及掛金)",
  RetirementAllowanceRefund = "退職手当金返還金",
  PrefecturalSubsidy = "都道府県補助金",
}

// 続柄
export enum Relationship {
  "戸籍上の配偶者" = "1",
  "内縁の妻又は夫" = "2",
  "子ども" = "3",
  "父母" = "4",
  "孫" = "5",
  "祖父母" = "6",
  "兄弟姉妹" = "7",
  "その他" = "8",
}

// 確認する書類の選択;
export enum CheckTextSelect {
  "個人番号カード（１２桁の番号のある面）" = "1",
  "個人番号が記載された住民票＋写真付き身分証明１点" = "2",
  "個人番号が記載された住民票＋写真無し身分証明２点" = "3",
  "通知カード＋写真付き身分証明１点" = "4",
  "通知カード＋写真無し身分証明２点" = "5",
}

// 申請フロー種別
export enum ApplicationFlowType {
  Type1 = "稟議あり&拒絶あり",
  Type2 = "稟議あり&拒絶なし",
  Type3 = "稟議なし",
  Type4 = "処理なし",
}

// 申請状態（機構）
export const ApplicationStatus = {
  "00": "届出待ち",
  "01": "受理待ち",
  "02": "再受理待ち",
  "03": "稟議・決裁結果待ち",
  "04": "課長代理確認待ち",
  "05": "課長代理確認（拒絶）待ち",
  "06": "上長承認待ち",
  "07": "上長承認（拒絶）待ち",
  "08": "通知待ち",
  "09": "通知（拒絶）待ち",
  "10": "契約者差戻し中",
  "11": "郵送待ち",
  "12": "郵送（拒絶）待ち",
  "13": "処理完了",
  "14": "処理（拒絶）完了",
  "15": "取下済",
  "16": "差戻し一時保存",
  "17": "添付待ち",
};

// 請求者区分
export enum DemanderKbn {
  "退職者本人" = "1",
  "相続人" = "2",
  "遺族" = "3",
}

// 帳票区分
export enum FormKbn {
  "申請" = "1",
  "統計" = "2",
  "法人書類" = "3",
  "施設書類" = "4",
  "職員書類" = "5",
  "退職書類" = "6",
}

// 帳票種別（申請）
export enum FormClassApply {
  "重要事項確認書" = "RPT0101021",
  "既契約掛金振込用紙依頼書" = "RPT0102029",
  "途中掛金・割増金振込用振込依頼書" = "RPT0102031",
  "特定介護保険施設等承諾書" = "RPT0203025",
  "申出施設等承諾書" = "RPT0203026",
  "掛金納付対象職員届" = "RPT0301009",
  "解除同意書" = "RPT0601049",
  "被共済職員退職届" = "RPT0701019",
  "退職手当金請求書" = "RPT0701048",
  "市町村民税・道府県民税納付書" = "RPT0703041",
  "社会福祉施設職員等退職手当共済契約申込書" = "EXP0101001",
  "社会福祉施設職員等退職手当共済契約申込書（学校法人用）" = "EXP0101002",
  "職員名簿" = "EXP0101003",
  "職員名簿（学校法人用）" = "EXP0101004",
  "退職手当共済契約証書" = "EXP0103024",
  "施設等新設届・申出書" = "EXP0201007",
  "（別紙）施設等新設届・申出書職員名簿" = "EXP0201008",
  "掛金納付期限延長申請書" = "EXP0301010",
  "掛金届未提出者一覧" = "EXP0304201",
  "掛金納付対象職員届確定状況一覧（社協等用）" = "EXP0305203",
  "掛金の返還請求決定通知について（通知文差込データ用）" = "EXP0402033",
  "掛金の過納額の返戻について（通知文差込データ用）" = "EXP0402034",
  "掛金過納・未納者リスト" = "EXP0404192",
  "過納金返還・割増金請求リスト" = "EXP0404194",
  "入金の出力データ" = "EXP0404208",
  "社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届" = "EXP0601011",
  "中小企業退職金共済契約締結届" = "EXP0601012",
  "共済契約者氏名等変更届・共済契約証書再交付申請書" = "EXP0601013",
  "退職手当共済契約解除通知書" = "EXP0601016",
  "退職手当共済契約部分解除通知書" = "EXP0601017",
  "従業状況報告書" = "EXP0601018",
  "「俸給の調整額」対象手当登録申請書" = "EXP0601020",
  "契約対象外施設等異動職員にかかる管理及び届出について（通知文差込データ用）" = "EXP0602038",
  "契約対象外施設等異動期限別リスト" = "EXP0604195",
  "退職手当金送金通知及び退職所得の源泉徴収票の再発行について" = "EXP0702036",
  "退職手当金支給予定調書" = "EXP0704027",
  "退職手当金支給決定調書" = "EXP0704028",
  "退職年度別・支給状況リスト" = "EXP0704043",
  "退職手当金等受給者別支払調書" = "EXP0704044",
  "源泉徴収税内訳表" = "EXP0704204",
  "時効該当者一覧表" = "EXP0704205",
  "時効該当予定者一覧表" = "EXP0704206",
  "遺族請求明細書" = "EXP0704207",
  "退職手当金支給明細（平均処理日数算出）" = "EXP0704209",
  "退職手当金振込先金融機関変更届" = "EXP0801006",
  "退職手当金振込先金融機関変更届について（差込データ用）" = "EXP0802035",
  "退職手当金の送金時期について（差込データ用）" = "EXP0802037",
  "預り金の時効対象者管理" = "EXP0804210",
  "都道府県別所要調書一覧（概算交付）" = "EXP0904019",
  "補助金精算額調書" = "EXP0904045",
  "補助金所要額調書" = "EXP0904046",
  "都道府県別所要調書一覧（追加交付）" = "EXP0904167",
}

// 帳票種別（法人書類）
export enum formClassCorp {
  "履歴事項全部証明書（写）" = "1",
  "就業規則" = "2",
  "給与規程" = "3",
  "掛金納付延長申請理由書" = "4",
  "法人口座（通帳）の写し" = "5",
  "廃止・休止が確認できる書類の添付" = "6",
  "契約解除同意書" = "7",
  "掛金振込依頼書" = "8",
  "掛金納付対象職員届控え" = "9",
}

// 帳票種別（施設書類）
export enum formClassFacility {
  "当該施設・事業を経営している証拠書類" = "1",
  "施設情報の変更事項が確認できる書類" = "2",
  "廃止・休止が確認できる書類の添付" = "3",
  "部分解除同意書" = "4",
}

// 帳票種別（職員書類）
export enum formClassStaff {
  "雇用契約書の写し" = "1",
  "共済契約対象外経営施設であることを確認できる書類" = "2",
}

// 帳票種別（退職書類）
export enum FormClassRetire {
  "賃金台帳" = "1",
  "仮退職年月日以前6ヶ月の給与台帳（写）" = "2",
  "雇用契約書" = "3",
  "雇用保険資格喪失証明書等" = "4",
  "就業規則（写）" = "5",
  "その他機構が求めた書類" = "6",
  "退職所得の源泉徴収票_退職届1枚目" = "7",
  "現認証明書（事務取扱要領　様式10-2号）" = "8",
  "現認証明書（事務取扱要領　様式10-3号）" = "9",
  "生計維持に関する調査書（様式11号）" = "10",
  "障害補償給付又は傷病補償年金の支給決定通知書（写）" = "11",
  "障害厚生年金の受給を証する書類又は医師の診断書" = "12",
  "死亡診断書（写）" = "13",
  "「死亡診断書」又は「死体検案書」（写）" = "14",
  "問題行動の概要が分かる書類" = "15",
  "懲戒処分・解雇の辞令（写）" = "16",
  "解雇処分について審議された議事録（写）" = "17",
  "事情聴取の調書等の記録書面（写）、自認書（写）" = "18",
  "判決書（写）" = "19",
  "新聞記事（写）" = "20",
  "職員の死亡当時の住民票の謄本" = "21",
  "事実上の配偶者であることを証明する書類" = "22",
  "本人確認書類" = "23",
  "本人確認書類（表面）" = "24",
  "本人確認書類（裏面）" = "25",
  "旧姓と新姓が確認できる住民票" = "26",
  "個人番号を確認する書類" = "27",
  "振込先口座が確認できる書類" = "28",
  "振込先金融口座が確認できる書類" = "29",
  "氏名が変更されていることを確認できる書類" = "30",
  "認証分つき法定相続情報一覧図の写し" = "31",
  "死亡職員「戸籍謄本」又は「除籍謄本」" = "32",
  "死亡職員と請求者関係証明の戸籍謄本" = "33",
  "請求者「戸籍抄本」又は「戸籍謄本」" = "34",
  "退職支給証明依頼の委任状" = "35",
  "退職支給証明依頼者の身分証明書（写）" = "36",
  "犯罪行為等による退職の確認書類" = "37",
  "死亡した退職者の個人番号を確認する書類" = "38",
  "退職所得の源泉徴収票_退職届2枚目" = "39",
  "退職所得の源泉徴収票_退職届3枚目" = "40",
  "退職所得の源泉徴収票_手当金請求1枚目" = "41",
  "退職所得の源泉徴収票_手当金請求2枚目" = "42",
  "委任状" = "43",
  "葬祭料の支給決定通知書（写）又は第三者行為災害届（写）" = "44",
}

// 施設種類(一般)
export enum GeneralFacilityType {
  "救護施設" = "0101",
  "更生施設" = "0102",
  "授産施設" = "0103",
  "宿所提供施設" = "0104",
  "乳児院（乳児預かり所を含む）" = "0201",
  "母子生活支援施設" = "0202",
  "保育所" = "0203",
  "児童養護施設" = "0204",
  "児童心理治療施設" = "0211",
  "児童自立支援施設" = "0212",
  "幼保連携型認定こども園" = "0214",
  "保育所（認定こども園移行）" = "0293",
  "養護老人ホーム" = "0301",
  "軽費老人ホーム（介護保険法の規定に基づく指定に係るものを除く）" = "0303",
  "視聴覚障害者情報提供施設（点字出版施設を除く）" = "0404",
  "身体障害者福祉センターの中の地域活動支援センターの事業に相当する事業" = "0409",
  "女性自立支援施設" = "0701",
  "社会事業授産施設" = "0702",
  "児童自立生活援助事業" = "0807",
  "小規模住居型児童養育事業" = "0827",
  "小規模保育事業" = "0830",
  "認定生活困窮者就労訓練事業" = "0831",
  "特別養護老人ホーム" = "3101",
  "軽費老人ホーム（介護保険法の規定に基づく指定に係るもの）" = "3102",
  "老人居宅介護等事業（ホームヘルプ）" = "3103",
  "小規模多機能型居宅介護事業" = "3104",
  "認知症対応型老人共同生活援助事業（グループホーム）" = "3105",
  "老人デイサービスセンター" = "3106",
  "老人短期入所施設" = "3107",
  "複合型サービス福祉事業" = "3108",
  "老人福祉センター内の老人デイサービス事業" = "3109",
  "障害児入所施設" = "3201",
  "居宅介護事業" = "3202",
  "行動援護事業" = "3203",
  "共同生活援助事業（グループホーム）" = "3204",
  "短期入所事業（ショートステイ）" = "3205",
  "重度訪問介護事業" = "3206",
  "重度障害者等包括支援事業" = "3207",
  "生活介護事業" = "3208",
  "療養介護事業" = "3209",
  "自立訓練事業" = "3210",
  "就労移行支援事業" = "3211",
  "就労継続支援事業" = "3212",
  "就労定着支援事業" = "3219",
  "自立生活援助事業" = "3220",
  "移動支援事業" = "3213",
  "同行援護事業" = "3214",
  "障害児通所支援事業" = "3215",
  "地域活動支援センター" = "3216",
  "福祉ホーム" = "3217",
  "障害者支援施設" = "3218",
  // "就労選択支援事業" = "3221", 2025/10/1まで表示されない
  "生計困難者助葬事業" = "5101",
  "無低利子資金融通事業" = "5102",
  "生活必需品等を与える事業" = "5103",
  "診療施設（医療保護施設）" = "5104",
  "診療施設（病院・診療所）" = "5105",
  "簡易住宅貸付・宿泊所利用事業" = "5106",
  "その他生活困難者施設・事業" = "5190",
  "助産施設" = "5201",
  "児童厚生施設" = "5202",
  "児童家庭支援センター" = "5203",
  "障害児相談支援事業" = "5204",
  "放課後児童健全育成事業" = "5205",
  "児童福祉増進相談事業" = "5206",
  "法定外保育施設" = "5207",
  "乳児家庭全戸訪問事業" = "5209",
  "養育支援訪問事業" = "5210",
  "地域子育て支援拠点事業" = "5211",
  "一時預かり事業" = "5212",
  "その他児童施設・事業" = "5290",
  "老人福祉センター" = "5301",
  "老人介護支援センター" = "5302",
  "介護老人保健施設" = "5303",
  "指定居宅介護支援事業" = "5304",
  "指定訪問看護事業" = "5305",
  "有料老人ホーム" = "5306",
  "老人憩いの家" = "5307",
  "老人休養ホーム" = "5308",
  "在宅介護支援センター" = "5309",
  "訪問入浴介護事業" = "5310",
  "地域包括支援センター" = "5311",
  "その他老人施設・事業" = "5390",
  "身体障害者福祉センター" = "5401",
  "補装具製作施設" = "5402",
  "盲導犬訓練施設" = "5403",
  "視聴覚障害者情報提供施設のうち点字出版施設" = "5404",
  "身体障害者生活訓練等事業" = "5406",
  "手話通訳事業" = "5407",
  "その他身体障害者施設・事業" = "5490",
  "その他知的障害者施設・事業" = "5590",
  "精神障害者居宅介護等事業" = "5601",
  "精神障害者短期入所事業" = "5602",
  "その他精神障害者施設・事業" = "5690",
  "相談支援事業" = "6001",
  "母子福祉センター" = "5701",
  "母子休養ホーム" = "5702",
  "母子家庭居宅介護等事業" = "5703",
  "寡婦居宅介護等事業" = "5704",
  "父子家庭居宅介護等事業" = "5705",
  "その他母子施設・事業" = "5790",
  "隣保事業" = "5801",
  "福祉サービス利用援助事業" = "5802",
  "社会福祉事業関連連絡事業" = "5803",
  "社会福祉事業関連助成事業" = "5804",
  "へき地保健福祉館" = "5805",
  "地域福祉センター" = "5806",
  "その他障害者施設・事業" = "5807",
  "法人関連事業" = "5808",
  "日中一時援助" = "5809",
  "小規模作業所" = "5810",
  "その他施設・事業" = "5890",
  "収益事業（販売業）" = "5901",
  "収益事業（出版事業）" = "5902",
  "収益事業（不動産賃貸）" = "5903",
  "その他の収益事業" = "5990",
  "契約外の社会福祉施設" = "9991",
  "老人保健施設" = "9992",
  "その他" = "9993",
}

// 施設種類（全量）
export const FacilityKind = {
  "0100": "保護施設",
  "0101": "救護施設",
  "0102": "更生施設",
  "0103": "授産施設",
  "0104": "宿所提供施設",
  "0200": "児童福祉施設",
  "0201": "乳児院（乳児預かり所を含む）",
  "0202": "母子生活支援施設",
  "0203": "保育所",
  "0204": "児童養護施設",
  "0205": "知的障害児施設",
  "0206": "知的障害児通園施設",
  "0207": "盲ろうあ児施設",
  "0209": "肢体不自由児施設",
  "0210": "重症心身障害児施設",
  "0211": "児童心理治療施設",
  "0212": "児童自立支援施設",
  "0213": "障害児入所施設",
  "0214": "幼保連携型認定こども園",
  "0293": "保育所（認定こども園移行）",
  "0300": "老人福祉施設",
  "0301": "養護老人ホーム",
  "0302": "特別養護老人ホーム",
  "0303": "軽費老人ホーム（介護保険法の規定に基づく指定に係るものを除く）",
  "0304": "ケアハウス",
  "0305": "老人デイサービス",
  "0306": "老人短期入所施設",
  "0900": "障害者自立支援法関連施設",
  "0901": "地域活動支援センター",
  "0902": "福祉ホーム",
  "0903": "障害者支援施設",
  "0400": "身体障害者更生援護施設",
  "0401": "身体障害者更生施設",
  "0402": "身体障害者療護施設",
  "0403": "身体障害者授産施設",
  "0404": "視聴覚障害者情報提供施設（点字出版施設を除く）",
  "0405": "身障デイサービス",
  "0406": "身体障害者福祉ホーム",
  "0407": "身体障害者福祉工場",
  "0408": "障害者デイサービス（センター）",
  "0409":
    "身体障害者福祉センターの中の地域活動支援センターの事業に相当する事業",
  "0500": "知的障害者援護施設",
  "0501": "知的障害者更生施設",
  "0502": "知的障害者授産施設",
  "0503": "知的障害者通勤寮",
  "0504": "知的障害者福祉ホーム",
  "0505": "知的障害者福祉工場",
  "0506": "知的障害者デイサービス",
  "0600": "精神障害者社会復帰施設",
  "0601": "精神障害者生活訓練施設",
  "0602": "精神障害者福祉ホーム",
  "0603": "精神障害者授産施設",
  "0604": "精神障害者福祉工場",
  "0605": "精神障害者地域生活支援センター",
  "0606": "精神障害者居宅介護等事業",
  "0607": "精神障害者短期入所事業",
  "0700": "その他の施設",
  "0701": "女性自立支援施設",
  "0702": "社会事業授産施設",
  "0703": "認定生活困窮者就労訓練事業",
  "0800": "特定社会福祉事業",
  "0801": "児童居宅介護等事業",
  "0802": "老人居宅介護等事業",
  "0803": "身体障害者居宅介護等事業",
  "0804": "知的障害者居宅介護等事業",
  "0805": "知的障害者地域生活援助事業",
  "0806": "精神障害者地域生活援助事業",
  "0807": "児童自立生活援助事業",
  "0808": "認知症対応型老人共同生活援助",
  "0809": "精神障害者居宅介護等事業",
  "0810": "精神障害者短期入所事業",
  "0811": "障害者デイサービス",
  "0812": "居宅介護（障害者）",
  "0813": "行動援護（障害者）",
  "0814": "外出介護（障害者）",
  "0815": "共同生活援助（障害者）",
  "0816": "短期入所（障害者）",
  "0817": "児童デイサービス",
  "0818": "重度訪問介護",
  "0819": "重度障害者等包括支援",
  "0820": "生活介護",
  "0821": "療養介護",
  "0822": "共同生活介護",
  "0823": "自立訓練",
  "0824": "就労移行支援",
  "0825": "就労継続支援",
  "0826": "移動支援事業",
  "0827": "小規模住居型児童養育事業",
  "0828": "同行援護",
  "0829": "障害児通所支援事業",
  "0830": "小規模保育事業",
  "0831": "認定生活困窮者就労訓練事業",
  "3100": "介護保険施設等",
  "3101": "特別養護老人ホーム",
  "3102": "軽費老人ホーム（介護保険法の規定に基づく指定に係るもの）",
  "3103": "老人居宅介護等事業（ホームヘルプ）",
  "3104": "小規模多機能型居宅介護事業",
  "3105": "認知症対応型老人共同生活援助事業（グループホーム）",
  "3106": "老人デイサービスセンター",
  "3107": "老人短期入所施設",
  "3108": "複合型サービス福祉事業",
  "3109": "老人福祉センター内の老人デイサービス事業",
  "3200": "障害者支援施設等",
  "3201": "障害児入所施設",
  "3202": "居宅介護事業",
  "3203": "行動援護事業",
  "3204": "共同生活援助事業（グループホーム）",
  "3205": "短期入所事業（ショートステイ）",
  "3206": "重度訪問介護事業",
  "3207": "重度障害者等包括支援事業",
  "3208": "生活介護事業",
  "3209": "療養介護事業",
  "3210": "自立訓練事業",
  "3211": "就労移行支援事業",
  "3212": "就労継続支援事業",
  "3219": "就労定着支援事業",
  "3220": "自立生活援助事業",
  "3213": "移動支援事業",
  "3214": "同行援護事業",
  "3215": "障害児通所支援事業",
  "3216": "地域活動支援センター",
  "3217": "福祉ホーム",
  "3218": "障害者支援施設",
  // "3221": "就労選択支援事業", 2025/10/1まで表示されない
  "5100": "生計困難者に対する施設・事業",
  "5101": "生計困難者助葬事業",
  "5102": "無低利子資金融通事業",
  "5103": "生活必需品等を与える事業",
  "5104": "診療施設（医療保護施設）",
  "5105": "診療施設（病院・診療所）",
  "5106": "簡易住宅貸付・宿泊所利用事業",
  "5190": "その他生活困難者施設・事業",
  "5200": "児童に対する施設・事業",
  "5201": "助産施設",
  "5202": "児童厚生施設",
  "5203": "児童家庭支援センター",
  "5204": "障害児相談支援事業",
  "5205": "放課後児童健全育成事業",
  "5206": "児童福祉増進相談事業",
  "5207": "法定外保育施設",
  "5208": "児童デイサービス事業",
  "5209": "乳児家庭全戸訪問事業",
  "5210": "養育支援訪問事業",
  "5211": "地域子育て支援拠点事業",
  "5212": "一時預かり事業",
  "5290": "その他児童施設・事業",
  "5300": "老人に対する施設・事業",
  "5301": "老人福祉センター",
  "5302": "老人介護支援センター",
  "5303": "介護老人保健施設",
  "5304": "指定居宅介護支援事業",
  "5305": "指定訪問看護事業",
  "5306": "有料老人ホーム",
  "5307": "老人憩いの家",
  "5308": "老人休養ホーム",
  "5309": "在宅介護支援センター",
  "5310": "訪問入浴介護事業",
  "5311": "地域包括支援センター",
  "5390": "その他老人施設・事業",
  "5400": "身体障害者に対する施設・事業",
  "5401": "身体障害者福祉センター",
  "5402": "補装具製作施設",
  "5403": "盲導犬訓練施設",
  "5404": "視聴覚障害者情報提供施設のうち点字出版施設",
  "5405": "身体障害者相談支援事業",
  "5406": "身体障害者生活訓練等事業",
  "5407": "手話通訳事業",
  "5408": "身体障害者小規模作業所",
  "5409": "身体障害者デイサービス事業・単",
  "5490": "その他身体障害者施設・事業",
  "5500": "知的障害者に対する施設・事業",
  "5501": "知的障害者相談支援事業",
  "5502": "知的障害者小規模作業所",
  "5503": "知的障害者デイサービス事業",
  "5590": "その他知的障害者施設・事業",
  "5600": "精神障害者に対する施設・事業",
  "5601": "精神障害者居宅介護等事業",
  "5602": "精神障害者短期入所事業",
  "5603": "精神障害者小規模作業所",
  "5690": "その他精神障害者施設・事業",
  "6000": "相談支援事業",
  "6001": "相談支援事業",
  "5700": "母子等に対する施設・事業",
  "5701": "母子福祉センター",
  "5702": "母子休養ホーム",
  "5703": "母子家庭居宅介護等事業",
  "5704": "寡婦居宅介護等事業",
  "5705": "父子家庭居宅介護等事業",
  "5790": "その他母子施設・事業",
  "5800": "その他の施設・事業",
  "5801": "隣保事業",
  "5802": "福祉サービス利用援助事業",
  "5803": "社会福祉事業関連連絡事業",
  "5804": "社会福祉事業関連助成事業",
  "5805": "へき地保健福祉館",
  "5806": "地域福祉センター",
  "5807": "その他障害者施設・事業",
  "5808": "法人関連事業",
  "5809": "日中一時援助",
  "5810": "小規模作業所",
  "5890": "その他施設・事業",
  "5900": "収益事業",
  "5901": "収益事業（販売業）",
  "5902": "収益事業（出版事業）",
  "5903": "収益事業（不動産賃貸）",
  "5990": "その他の収益事業",
  "9900": "その他施設",
  "9991": "契約外の社会福祉施設",
  "9992": "老人保健施設",
  "9993": "その他",
};

// 施設区分（表示）
export enum FacilityKbn {
  "社会福祉施設等" = "1",
  "申出施設等" = "2",
  "特定介護保険施設等" = "3",
}

// 施設区分
export enum FacilityType {
  "社福" = "1",
  "申出" = "2",
  "特介" = "3",
}

// 退職区分
export enum RetireKbn {
  "一般" = "1",
  "障害" = "2",
}

//退職手当金支給状況
export enum RetirementProvisionStatus {
  "すべて" = "null",
  "未支給" = "0",
  "支給済み" = "1",
}

// 退職時処理区分
export enum ApplyTkKind {
  "退職手当金" = "0",
  "合算" = "1",
}

// 提出方法
export enum submitWay {
  "紙" = "0",
  "システム" = "1",
}

// 手当区分
export enum BenefitsKbn {
  "特殊業務手当" = "1",
  "給与特別改善手当" = "2",
  "その他" = "3",
}

// 経営者でなくなった理由
export enum NoOwnerReason {
  "組織変更" = "ア",
  "法人解散" = "イ",
  "廃止" = "ウ",
  "休止" = "エ",
  "公営移管" = "オ",
  "死亡" = "カ",
  "交代" = "キ",
  "その他" = "ク",
}

// 銀行
export interface bankList {
  bankCode: string;
  bankName: string;
  bankNameKatakana: string;
}

export const banks: readonly bankList[] = [
  { bankCode: "0001", bankName: "みずほ銀行", bankNameKatakana: "ﾐｽﾞﾎ" },
  {
    bankCode: "0005",
    bankName: "三菱UFJ銀行",
    bankNameKatakana: "ﾐﾂﾋﾞｼﾕ-ｴﾌｼﾞｴｲ",
  },
  { bankCode: "0009", bankName: "三井住友銀行", bankNameKatakana: "ﾐﾂｲｽﾐﾄﾓ" },
  { bankCode: "0010", bankName: "りそな銀行", bankNameKatakana: "ﾘｿﾅ" },
  { bankCode: "0017", bankName: "埼玉りそな銀行", bankNameKatakana: "ｻｲﾀﾏﾘｿﾅ" },
  { bankCode: "9900", bankName: "ゆうちょ銀行", bankNameKatakana: "ﾕｳﾁﾖ" },
  {
    bankCode: "0033",
    bankName: "PayPay銀行",
    bankNameKatakana: "ﾍﾟｲﾍﾟｲ",
  },
  { bankCode: "0034", bankName: "セブン銀行", bankNameKatakana: "ｾﾌﾞﾝ" },
  { bankCode: "0035", bankName: "ソニー銀行", bankNameKatakana: "ｿﾆ-" },
  { bankCode: "0036", bankName: "楽天銀行", bankNameKatakana: "ﾗｸﾃﾝ" },
  {
    bankCode: "0038",
    bankName: "住信SBIネット銀行",
    bankNameKatakana: "ｽﾐｼﾝｴｽﾋﾞ-ｱｲﾈﾂﾄ",
  },
];

// ワークフロー用表示ボタン判定
export enum Status {
  "届出待ち" = "00",
  "受理待ち" = "01",
  "再受理待ち" = "02",
  "稟議決裁結果待ち" = "03",
  "課長代理確認待ち" = "04",
  "課長代理確認拒絶待ち" = "05",
  "上長承認待ち" = "06",
  "上長承認拒絶待ち" = "07",
  "通知待ち" = "08",
  "通知拒絶待ち" = "09",
  "契約者差戻し中" = "10",
  "郵送待ち" = "11",
  "郵送拒絶待ち" = "12",
  "処理完了" = "13",
  "処理拒絶完了" = "14",
  "取下済" = "15",
  "差戻し一時保存" = "16",
  "添付待ち" = "17",
}

export enum YeaerStatus {
  "未確定" = "0",
  "確定中" = "1",
  "確定済" = "2",
  "過去年度" = "3",
}
// 申請イベント
export const applyEvent = {
  作成: "0",
  届出: "1",
  受理: "2",
  承認: "3",
  拒絶: "4",
  契約者に差戻し: "5",
  上長承認: "6",
  上長拒絶承認: "7",
  担当者に差戻し: "8",
  通知: "9",
  拒絶通知: "10",
  郵送: "11",
  再届出: "12",
  取下げ: "13",
  課長代理確認: "14",
  課長代理拒絶確認: "15",
};

// 譲渡先法人へ異動
export enum TransferStatus {
  "選択" = "1",
  "未選択" = "0",
}

// 退職者
export enum RetireeStatus {
  "選択" = "1",
  "未選択" = "0",
}

// 請求者続柄
export enum DemanderRelationship {
  "本人" = "0",
  "戸籍上の配偶者" = "1",
  "内縁の妻又は夫" = "2",
  "子ども" = "3",
  "父母" = "4",
  "孫" = "5",
  "祖父母" = "6",
  "兄弟姉妹" = "7",
  "その他" = "8",
}

// 国内居住
export enum DomesticResidenceFlg {
  "居住" = "1",
  "非居住" = "0",
}

// 入金状況
export enum PaymentStatus {
  "入金待ち" = "1",
  "入金完了" = "2",
}

// 請求区分（機構から）
export enum BillingTypeFormFacility {
  "既契約掛金（既契約法人）" = "1",
  "既契約掛金（新規契約法人）" = "2",
  "割増金（既契約掛金）" = "3",
  "途中掛金（新規契約掛金法人）" = "4",
  "割増金（途中掛金）" = "5",
  "途中掛金（遡及掛金）" = "6",
  "退職手当金返還金" = "7",
  "都道府県補助金" = "8",
}

// メール種別
export enum EmailClass {
  "システム案内メール用テンプレート" = "1",
  "定期案内メール用テンプレート" = "2",
  "職員手動メール用テンプレート" = "3",
  "通知メール用テンプレート" = "4",
}

// 退職理由
export enum RetireReason {
  "普通退職" = "1",
  "業務上の傷病又は業務上の死亡による退職" = "2",
  "犯罪等による退職" = "3",
}

// 退職手続きの理由
export enum RetireFlowReason {
  "自己都合（結婚、定年、雇用期間満了等）" = "11",
  "職員の死亡" = "12",
  "法人（業務上の）都合" = "13",
  "傷病による退職" = "21",
  "死亡による退職" = "22",
}
// 退職手続きの理由(普通退職)
export enum NormalRetireFlowReason {
  "自己都合（結婚、定年、雇用期間満了等）" = "11",
  "職員の死亡" = "12",
  "法人（業務上の）都合" = "13",
}
// 退職手続きの理由(業務上の疾病又は死亡による退職)
export enum IllnessAndDeathRetireFlowReason {
  "傷病による退職" = "21",
  "死亡による退職" = "22",
}

// 半年延長理由
export enum HalfYearExtensionReason {
  "半年延長無し" = "0",
  "保育所に入所を希望しているが入所できない" = "1",
  "子の養育を行っている配偶者であって、１歳以降子を養育する予定であったものが死亡、負傷、疾病等の事情により子を養育することが困難になった。" = "2",
  "パパ・ママ育児休業" = "3",
}

// 半年延長の理由(育児休業情報登録用)
export enum HalfYearExtensionReasonForChildcareLeave {
  "１．保育所等に入所を希望しているが、１歳（又は１歳６か月）に達する日後の期間について、入所できない場合" = "1",
  "２．子の養育を行っている配偶者であって、１歳（又は１歳６か月）に達する日後の期間について、子の養育を行う予定であった者が、死亡・負傷・疾病等、離婚等により子の養育することができなくなった場合" = "2",
}

// 源泉徴収票・特別徴収票の区分
export enum WithholdingSlipKbn {
  "所得税法第 201 条第1項1号並びに地方税第 50 条の6第1項1号及び第 328 条6第1項1号適用分" = "1",
  "所得税法第 201 条第1項2号並びに地方税第 50 条の6第1項2号及び第 328 条6第1項2号適用分" = "2",
  "所得税法第 201 条第3項並びに地方税第 50 条の6第2項及び第 328 条6第2項適用分" = "3",
}

// 各種契約者情報検索結果表示対象
export enum InquiryResultDisplayType {
  "法人" = "1",
  "施設" = "2",
  "職員" = "3",
}

// 宛先１
export enum Address1 {
  "既存の宛先を選択" = "1",
  "個別に宛先を指定" = "2",
}

// 宛先１
export enum Address1_2 {
  "既存の宛先を選択" = "1",
  "個別に宛先を指定" = "2",
  "個別に宛先を入力" = "3",
}

// 宛先２
export enum Address2 {
  "全共済契約者" = "1",
  "都道府県（施設の所在地）単位の共済契約者" = "2",
}

// 送信タイミング区分
export enum DestinationTimingKbn {
  "月次" = "1",
  "四半期" = "2",
  "年次" = "3",
  "個別に指定" = "4",
}

// 手続き名（契約者）
export enum ProcedureName {
  "共済契約の申込み連絡" = "JOB-73",
  "共済契約の申込み" = "JOB-01",
  "共済契約の解除(なくなった者)" = "JOB-02",
  "共済契約の解除(中退共)" = "JOB-03",
  "共済契約の解除（同意解除）" = "JOB-04",
  "名称等の変更(契約者)" = "JOB-05",
  "証書再交付" = "JOB-06",
  "調整額の申請" = "JOB-07",
  "従業状況更新" = "JOB-10",
  "掛金届" = "JOB-11",
  "掛金納付" = "JOB-79",
  "都道府県社協等への同意" = "JOB-80",
  "期限延長" = "JOB-12",
  "返戻請求" = "JOB-14",
  "施設等の新設" = "JOB-15",
  "契約の部分解除" = "JOB-16",
  "施設種類の変更" = "JOB-17",
  "施設等の廃止" = "JOB-18",
  "名称等の変更(施設)" = "JOB-19",
  "特定職員数等の変更" = "JOB-20",
  "新規職員の非加入" = "JOB-21",
  "非加入の取下げ" = "JOB-22",
  "職員の加入" = "JOB-23",
  "本俸月額更新" = "JOB-26",
  "配置換え" = "JOB-27",
  "異動届" = "JOB-28",
  "継続異動（加入）" = "JOB-30",
  "退職届" = "JOB-31",
  "継続異動（退職）" = "JOB-33",
  "退職届の取下げ" = "JOB-34",
  "退職金請求" = "JOB-35",
  "合算届（退職）" = "JOB-36",
  "退職金予定額証明" = "JOB-47",
  "閲覧請求" = "JOB-44",
  "メールアドレス変更" = "JOB-76",
}

// 手続き名（要処理一覧での処理）
export enum ProcedureKiko {
  "共済契約の申込み連絡" = "JOB-73",
  "共済契約の申込み" = "JOB-01",
  "共済契約の解除（なくなった者）" = "JOB-02",
  "共済契約の解除（中退共）" = "JOB-03",
  "共済契約の解除（同意解除）" = "JOB-04",
  "名称等の変更" = "JOB-05",
  "証書再交付" = "JOB-06",
  "調整額の申請" = "JOB-07",
  "法令違反解除" = "JOB-09",
  "掛金届" = "JOB-11",
  "期限延長" = "JOB-12",
  "割増金" = "JOB-13",
  "返戻請求依頼" = "JOB-75",
  "返戻請求" = "JOB-14",
  "返戻請求（グループ化）" = "JOB-86",
  "施設等の新設" = "JOB-15",
  "施設等の新設（グループ化）" = "JOB-92",
  "契約の部分解除" = "JOB-16",
  "施設種類の変更" = "JOB-17",
  "施設等の廃止" = "JOB-18",
  "特定職員数等の変更" = "JOB-20",
  "新規職員の非加入" = "JOB-21",
  "非加入の取下げ" = "JOB-22",
  "職員の加入" = "JOB-23",
  "異動届" = "JOB-28",
  "退職届" = "JOB-31",
  "継続異動（退職）" = "JOB-33",
  "退職届の取下げ" = "JOB-34",
  "退職金請求" = "JOB-35",
  "合算届（退職）" = "JOB-36",
  "退職金請求の取下げ" = "JOB-37",
  "振込先金融機関の変更" = "JOB-39",
  "振込先金融機関の変更（グループ化）" = "JOB-91",
  "受領者変更（連絡）" = "JOB-40",
  "受領者変更（請求）" = "JOB-41",
  "追加支給" = "JOB-42",
  "退職金の返還" = "JOB-43",
  "振込金返還請求（グループ化）" = "JOB-87",
  "退職金予定額証明" = "JOB-74",
  "閲覧請求" = "JOB-78",
  "源泉徴収票発行" = "JOB-48",
  "加入日等の訂正" = "JOB-49",
  "追納・返戻対応" = "JOB-50",
  "追加納付又は返戻情報の対応（グループ化）" = "JOB-88",
  "補助金請求" = "JOB-51",
  "既契約掛金" = "JOB-52",
  "既契約掛金（新規）" = "JOB-53",
  "途中掛金（新規）" = "JOB-54",
  "割増金（既契約）" = "JOB-55",
  "割増金（途中掛金）" = "JOB-56",
  "遡及掛金" = "JOB-57",
  "組戻金" = "JOB-58",
  "返還金" = "JOB-59",
  "返納金" = "JOB-60",
  "税金還付金" = "JOB-61",
  "給付費補助金" = "JOB-62",
  "仮受金（付替）" = "JOB-63",
  "仮受金（返戻）" = "JOB-64",
  "振込取消" = "JOB-65",
  "その他" = "JOB-66",
  "支給予定調書" = "JOB-67",
  "振込先金融機関変更依頼" = "JOB-70",
  "振込先金融機関変更依頼（グループ化）" = "JOB-90",
  "過納金返戻" = "JOB-68",
  "誤入金返戻" = "JOB-71",
  "過納金返戻承認" = "JOB-72",
  "連絡掲示板" = "JOB-45",
  "メールアドレス変更" = "JOB-76",
  "補助金交付申請情報登録" = "JOB-82",
}

// 手続き名（テンプレート）
export enum ProcedureTemplate {
  "施設等の新設" = "PROC0301",
  "契約の部分解除" = "PROC0302",
  "施設種類の変更" = "PROC0303",
  "施設等の廃止" = "PROC0304",
  "名称等の変更" = "PROC0305",
  "特定職員数等の変更" = "PROC0306",
  "新規職員の非加入" = "PROC0307",
  "非加入の取下げ" = "PROC0308",
}

// 退職手当金請求の順番
export enum RetirementInvoiceOrder {
  "福祉医療機構を先に請求" = "1",
  "福祉医療機構を後に請求" = "0",
}
// 添付書類登録状態
export enum AttachmentRegistStatus {
  "不要" = "0",
  "登録済" = "1",
  "後で登録" = "9",
}

// 源泉徴収登録状態
export enum WithholdTaxRegistStatus {
  "不要" = "0",
  "1枚登録" = "1",
  "2枚登録" = "2",
  "3枚登録" = "3",
  "後で登録" = "9",
}

// 施設区分１
export enum FacilityKbnList1 {
  "介護" = "0",
  "障害" = "1",
  "保育" = "2",
}

// 施設区分２
export enum FacilityKbnList2 {
  "Ｈ１８年制度改正前新設（介護）" = "0",
  "Ｈ１８年制度改正後新設（介護）" = "1",
  "Ｈ２８年制度改正前新設（障害）" = "2",
  "Ｈ２８年制度改正後新設（障害）" = "3",
  "社会福祉施設のみ" = "4",
  "申出施設のみ" = "5",
}

// 加入状況１
export enum MembershipStatusList1 {
  "4/1時点在籍者" = "0",
  "現在在籍者" = "1",
  "退職者（全て）" = "2",
  "退職者（退職届未提出）" = "3",
  "退職者（退職届提出済み、請求書未提出）" = "4",
  "契約外異動者" = "5",
  "加入日開始" = "6",
  "加入日終了" = "7",
}

// 加入状況２
export enum MembershipStatusList2 {
  "Ｈ１８年制度改正後加入者（全て）" = "0",
  "Ｈ１８年制度改正後加入者（4/1在籍）" = "1",
  "Ｈ２８年制度改正後加入者（全て）" = "2",
  "Ｈ２８年制度改正後加入者（4/1在籍）" = "3",
  "Ｈ１８年制度改正後Ｈ２８年改正前加入者（全て）" = "4",
  "Ｈ１８年制度改正後Ｈ２８年改正前加入者（4/1在籍）" = "5",
}

// 移行ユーザ
export enum Migration {
  "miguser" = "miguser",
}

// 補助金申請区分
export enum SubsidyApplyKbn {
  "概算交付申請" = "1",
  "追加交付申請" = "2",
}

// 掲示板発信区分
export enum PostKbn {
  "機構" = "1",
  "法人" = "2",
}

// 添付書類登録状態（今すぐ登録/後で登録）
export enum FileRegistStatus {
  "今すぐ登録" = "1",
  "後で登録" = "9",
}
// 添付書類登録状態（今すぐ登録/後で登録/添付しない）
export enum FileRegistStatusOptionalAttachments {
  "今すぐ登録" = "1",
  "後で登録" = "9",
  "添付しない" = "0",
}
// 所属課
export enum DivisionList {
  "退職共済課" = "1",
  "退職給付課" = "2",
}

// 所属係
export enum UnitList {
  "企画係" = "1",
  "管理係" = "2",
  "給付一係" = "3",
  "給付二係" = "4",
}

// 階級
export enum TitleClass {
  "係員" = "1",
  "係長" = "2",
  "課長代理" = "3",
  "課長" = "4",
  "部長" = "5",
}
//権限ステータス
export enum AuthStatus {
  "利用中" = "0",
  "削除済み" = "1",
}

// 異動理由
export const TransferReason = {
  加入: "1",
  退職: "2",
  配置換増: "3",
  配置換減: "4",
  適用復帰増: "5",
  適用外異動減: "6",
  継続異動増: "7",
  継続異動減: "8",
  合算申出増: "9",
  合算申出減: "10",
  経営移管増: "11",
  経営移管減: "12",
  "解除（中小企業退職共済契約締結）": "13",
  "解除（被共済職員の同意）": "14",
  "解除（法令違反）": "15",
  "解除（部分解除・施設全体）": "16",
  "解除（部分解除・平成18年4月1日以降の加入者対象）": "17",
  "解除（部分解除・平成28年4月1日以降の加入者対象）": "18",
  "解除（部分解除・設等で、転換日以降以降の加入者対象）": "19",
  退職の取下げ: "20",
  一部廃止による配置換え減: "99",
  仮廃籍後合算増: "21",
};

// 異動理由(異動履歴)
export const TransferHistoryReason = {
  加入: "1",
  退職: "2",
  配置換増: "3",
  配置換減: "4",
  復帰: "5",
  契約対象外: "6",
  継続異動増: "7",
  継続異動減: "8",
  合算申出増: "9",
  合算申出減: "10",
  経営移管増: "11",
  経営移管減: "12",
  退職の取下げ: "20",
  一部廃止による配置換え減: "99",
  仮廃籍後合算増: "21",
};

// 共済法令違反内容
export enum ViolationDetails {
  "掛金未納" = "1",
  "法令違反" = "2",
  "移行データのため不明" = "9",
}

// ステータス
export enum AccountStatus {
  "利用中" = "1",
  "利用停止" = "2",
  "未利用" = "3",
}

// 請求者
export enum Demander {
  "共済契約者" = "1",
  "法人職員" = "2",
  "弁護士" = "3",
}

// 回答種類
export enum AnswerType {
  "回答可能" = "1",
  "回答不可" = "0",
}

// 支給乗率
export enum MultiplyingFactor {
  "普通退職の乗率を適用" = "1",
  "業務上の疾病又は死亡による乗率を適用" = "2",
}

// 対応状態
export enum HandleStatus {
  "未対応" = "0",
  "不要" = "1",
  "手続中" = "2",
  "完了" = "3",
  "取下" = "4",
  "削除" = "5",
  "差戻し" = "6",
}

// 該当非該当フラグ
export enum ApplicableOrNotApplicable {
  "該当" = "1",
  "非該当" = "0",
}

// 入金区分
export enum DepositCategory {
  "既契約掛金（既契約法人）" = "1",
  "既契約掛金（新規契約法人）" = "2",
  "割増金（既契約掛金）" = "3",
  "途中掛金（新規契約掛金法人）" = "4",
  "割増金（途中掛金）" = "5",
  "途中掛金（遡及掛金）" = "6",
  "組戻金（退職手当金一時預かり金）" = "7",
  "退職手当金返還金" = "8",
  "返納金" = "9",
  "税金還付金" = "10",
  "給付費補助金" = "11",
  "都道府県補助金" = "12",
  "仮受金（付替）" = "13",
  "仮受金（返戻）" = "14",
  "振込取消（依頼組戻し）" = "15",
  "その他" = "16",
}

// 入金区分（手動設定）
export enum DepositCategoryManual {
  "退職手当金返還金" = "8",
  "返納金" = "9",
  "税金還付金" = "10",
  "給付費補助金" = "11",
  "都道府県補助金" = "12",
  "仮受金（付替）" = "13",
  "仮受金（返戻）" = "14",
  "振込取消（依頼組戻し）" = "15",
  "その他" = "16",
}

// 機構口座区分
export enum FinancialAccountType {
  "既契約掛金口座（1087649）" = "1",
  "途中掛金口座（1087656）" = "2",
}

// 紐づけ状況
export enum SortingStatus {
  "仕分け待ち" = "0",
  "仕分け済み" = "1",
}

// 年度確定状態
export enum ConfirmStatus {
  "未確定" = "0",
  "確定中" = "1",
  "確定済" = "2",
  "過去年度" = "3",
}

// 所得税法等の区分
export enum IncomeKbn {
  "所得税法第201条第１項第１号並びに地方税法第50条の６第１項第１号及び第328条の６第１項第１号適用分" = "1",
  "所得税法第201条第１項第２号並びに地方税法第50条の６第１項第２号及び第328条の６第１項第２号適用分" = "2",
  "所得税法第201条第３項並びに地方税法第50 条の６第２項及び第328条の６第２項適用分" = "3",
}

// 配置換え区分フラグ
export enum RelocationFlag {
  "配置換え元" = "0",
  "配置換え先" = "1",
}

// パパ・ママ育休プラス
export enum PapaMamaPlus {
  "無" = "0",
  "有" = "1",
}

//法人申請区分
export enum CorporationApplicationKbn {
  "紙申請法人" = "0",
  "電子申請法人" = "1",
}

//収納状態
export enum CollectionStatus {
  "請求中" = "0",
  "一部入金" = "1",
  "入金済み" = "2",
  "過納" = "3",
  "過納金返還済み" = "4",
  "請求対象外" = "5",
}

//被共済職員退職届.退職届のみ提出理由
export enum FormOnlyReason {
  "退職者の所在が不明" = "1",
  "退職者が請求を放棄している" = "2",
  "退職者の被共済職員期間が1年未満の場合" = "3",
}

// 不着理由
export enum NonDeliveryReason {
  "該当口座なし" = "1",
  "銀行名相違" = "2",
  "口座解約済" = "3",
  "支店相違" = "4",
  "科目相違" = "5",
  "口座番号相違" = "6",
  "名義相違" = "7",
  "組み戻し" = "8",
  "その他" = "9",
}
// 施設廃止理由
export enum AbolitionReason {
  "ア　廃止" = "ｱ",
  "イ　休止" = "ｲ",
  "ウ　経営移管" = "ｳ",
}
// 基本事項①記載内容
export enum AasicItemYesNo {
  "はい、表記があります" = "1",
}
//帳票出力状態
export enum FormOutputStatus {
  "処理待ち" = "1",
  "出力中" = "2",
  "出力完了" = "3",
  "エラー" = "4",
  "再出力待ち" = "5",
}
//処理タイプ
export enum ProcessType {
  "年度末統計出力" = "1",
  "確定統計出力" = "2",
  "データダウンロード" = "3",
  "印刷データ出力" = "4",
}

//宛先（抽出条件）
export enum DestinationType {
  "法人宛" = "1",
  "施設宛" = "2",
  "退職者宛" = "3",
}
//法人宛詳細条件（抽出条件）
export enum HoujinnType {
  "法人全て" = "1",
  "紙法人" = "2",
  "システム利用法人" = "3",
  "法人を指定" = "4",
}
//表示切替（抽出条件）
export enum DisplaySwitching {
  "すべて" = "1",
  "ダウンロード未実行" = "2",
}

// 割増金区分
export enum AdditionalChargeKbn {
  "割増金（既契約掛金）" = "3",
  "割増金（途中掛金）" = "5",
}
//法人アクセスURLid
export const accessId = "access_id";
// 出力済フラグ
export enum OutputFlg {
  "出力済" = "1",
  "未出力" = "0",
}

// 対応日
export enum DueDateList {
  "過去１ヶ月" = "1",
  "過去３ヶ月" = "2",
  "過去６ヶ月" = "3",
  "過去１年" = "4",
  "過去１年以上" = "5",
  "自分で選択" = "6",
}

// 手続き名
export enum ProcedureName98 {
  "加入届" = "1",
  "本俸/調整額の更新" = "2",
  "従業状況の更新" = "3",
  "配置換え（対象外異動含む）" = "4",
  "退職届" = "5",
  "退職届（施設単位）" = "6",
  "退職届（添付待ち）" = "7",
}
//  被共済職員でなくなった理由
export enum MasQuitReason {
  "退職" = "1",
  "解除" = "2",
  "合算申出" = "3",
}

// 各種契約者情報検索結果表示対象
export enum DepositType {
  "普通" = "1",
  "当座" = "2",
}

// 各種契約者情報検索結果表示対象(表示用)
export enum DispDepositType {
  "普通" = "1",
}
// 提出状況151
export enum subState {
  "未提出" = "0",
  "提出済み" = "1",
}

// 送信成否
export enum SendType {
  "送信待ち" = "0",
  "送信成功" = "1",
  "送信失敗" = "2",
}

//退職届・継続異動届の区分
export enum RetireContinuousTransferClassification {
  "継続異動以外" = "0",
  "継続異動" = "1",
}

//退職手当金の請求/合算制度利用申出の利用状況
export enum RetirementAllowanceInvoiceTotalingApplyUseStatus {
  "未提出" = "0",
  "退職金請求済み" = "1",
  "合算済み" = "2",
  "退職金請求済み(受理待ち)" = "3",
}

// 対象外施設異動区分
export enum TransferKbn {
  "転出" = "1",
  "復帰" = "2",
}

// 支払区分
export enum PaymentKbn {
  "退職手当金" = "1",
  "源泉徴収振込金" = "2",
  "退職手当金再送金" = "3",
  "過納金返還金" = "4",
  "その他" = "5",
}
//業務タイプ（代行者履歴検索）
export enum ProcedureName179 {
  "加入届" = "JOB-23",
  "本俸/調整額の更新" = "JOB-26",
  "従業状況の更新" = "JOB-25",
  "配置換え（対象外異動含む）" = "JOB-27",
  "退職届" = "JOB-32",
  "退職届（施設単位）" = "JOB-32",
}

// 施設種類（社福除く）
export enum TransferdFacilityType {
  "特別養護老人ホーム" = "3101",
  "軽費老人ホーム（介護保険法の規定に基づく指定に係るもの）" = "3102",
  "老人居宅介護等事業（ホームヘルプ）" = "3103",
  "小規模多機能型居宅介護事業" = "3104",
  "認知症対応型老人共同生活援助事業（グループホーム）" = "3105",
  "老人デイサービスセンター" = "3106",
  "老人短期入所施設" = "3107",
  "複合型サービス福祉事業" = "3108",
  "老人福祉センター内の老人デイサービス事業" = "3109",
  "障害児入所施設" = "3201",
  "居宅介護事業" = "3202",
  "行動援護事業" = "3203",
  "共同生活援助事業（グループホーム）" = "3204",
  "短期入所事業（ショートステイ）" = "3205",
  "重度訪問介護事業" = "3206",
  "重度障害者等包括支援事業" = "3207",
  "生活介護事業" = "3208",
  "療養介護事業" = "3209",
  "自立訓練事業" = "3210",
  "就労移行支援事業" = "3211",
  "就労継続支援事業" = "3212",
  "移動支援事業" = "3213",
  "同行援護事業" = "3214",
  "障害児通所支援事業" = "3215",
  "地域活動支援センター" = "3216",
  "福祉ホーム" = "3217",
  "障害者支援施設" = "3218",
  "就労定着支援事業" = "3219",
  "自立生活援助事業" = "3220",
  // "就労選択支援事業" = "3221", 2025/10/1まで表示されない
  "生計困難者助葬事業" = "5101",
  "無低利子資金融通事業" = "5102",
  "生活必需品等を与える事業" = "5103",
  "診療施設（医療保護施設）" = "5104",
  "診療施設（病院・診療所）" = "5105",
  "簡易住宅貸付・宿泊所利用事業" = "5106",
  "その他生活困難者施設・事業" = "5190",
  "助産施設" = "5201",
  "児童厚生施設" = "5202",
  "児童家庭支援センター" = "5203",
  "障害児相談支援事業" = "5204",
  "放課後児童健全育成事業" = "5205",
  "児童福祉増進相談事業" = "5206",
  "法定外保育施設" = "5207",
  "児童デイサービス事業" = "5208",
  "乳児家庭全戸訪問事業" = "5209",
  "養育支援訪問事業" = "5210",
  "地域子育て支援拠点事業" = "5211",
  "一時預かり事業" = "5212",
  "その他児童施設・事業" = "5290",
  "老人福祉センター" = "5301",
  "老人介護支援センター" = "5302",
  "介護老人保健施設" = "5303",
  "指定居宅介護支援事業" = "5304",
  "指定訪問看護事業" = "5305",
  "有料老人ホーム" = "5306",
  "老人憩いの家" = "5307",
  "老人休養ホーム" = "5308",
  "在宅介護支援センター" = "5309",
  "訪問入浴介護事業" = "5310",
  "地域包括支援センター" = "5311",
  "その他老人施設・事業" = "5390",
  "身体障害者福祉センター" = "5401",
  "補装具制作施設" = "5402",
  "盲導犬訓練施設" = "5403",
  "視聴覚障害者情報提供施設のうち点字出版施設" = "5404",
  "身体障害者相談支援事業" = "5405",
  "身体障害者生活訓練等事業" = "5406",
  "手話通訳事業" = "5407",
  "身体障害者小規模作業所" = "5408",
  "身体障害者デイサービス事業・単" = "5409",
  "その他身体障害者施設・事業" = "5490",
  "知的障害者相談支援事業" = "5501",
  "知的障害者小規模作業所" = "5502",
  "知的障害者デイサービス事業" = "5503",
  "その他知的障害者施設・事業" = "5590",
  "精神障害者居宅介護等事業" = "5601",
  "精神障害者短期入所事業" = "5602",
  "精神障害者小規模作業所" = "5603",
  "その他精神障害者施設・事業" = "5690",
  "母子福祉センター" = "5701",
  "母子休養ホーム" = "5702",
  "母子家庭居宅介護等事業" = "5703",
  "寡婦居宅介護等事業" = "5704",
  "父子家庭居宅介護等事業" = "5705",
  "その他母子施設・事業" = "5790",
  "隣保事業" = "5801",
  "福祉サービス利用援助事業" = "5802",
  "社会福祉事業関連連絡事業" = "5803",
  "社会福祉事業関連助成事業" = "5804",
  "へき地保健福祉館" = "5805",
  "地域福祉センター" = "5806",
  "その他障害者施設・事業" = "5807",
  "法人関連事業" = "5808",
  "日中一時援助" = "5809",
  "小規模作業所" = "5810",
  "その他施設・事業" = "5890",
  "収益事業（販売業）" = "5901",
  "収益事業（出版事業）" = "5902",
  "収益事業（不動産賃貸）" = "5903",
  "その他の収益事業" = "5990",
  "相談支援事業" = "6001",
  "契約外の社会福祉施設" = "9991",
  "老人保健施設" = "9992",
  "その他" = "9993",
}

// 手続き名（契約者未処理申請・届出）
export enum Unprocessed {
  "共済契約の申込み" = "JOB-01",
  "共済契約の解除（なくなった者）" = "JOB-02",
  "共済契約の解除（中退共）" = "JOB-03",
  "共済契約の解除（同意解除）" = "JOB-04",
  "名称等の変更（契約者）" = "JOB-05",
  "証書再交付" = "JOB-06",
  "調整額の申請" = "JOB-07",
  "従業状況更新" = "JOB-10",
  "掛金届" = "JOB-11",
  "掛金納付" = "JOB-79",
  "都道府県社協等への同意" = "JOB-80",
  "期限延長" = "JOB-12",
  "割増金" = "JOB-13",
  "返戻請求依頼" = "JOB-75",
  "返戻請求" = "JOB-14",
  "施設等の新設" = "JOB-15",
  "契約の部分解除" = "JOB-16",
  "施設種類の変更" = "JOB-17",
  "施設等の廃止" = "JOB-18",
  "名称等の変更（施設）" = "JOB-19",
  "特定職員数等の変更" = "JOB-20",
  "新規職員の非加入" = "JOB-21",
  "職員の加入" = "JOB-23",
  "異動届" = "JOB-28",
  "継続異動（加入）" = "JOB-30",
  "退職届" = "JOB-31",
  "継続異動（退職）" = "JOB-33",
  "退職金請求" = "JOB-35",
  "合算届（退職）" = "JOB-36",
  "振込先金融機関の変更" = "JOB-39",
  "受領者変更（連絡）" = "JOB-40",
  "受領者変更（請求）" = "JOB-41",
  "退職金予定額証明" = "JOB-47",
  "閲覧請求" = "JOB-44",
}

// 回数
export enum ReminderCount {
  "1回目" = "1",
  "2回目" = "2",
  "3回目" = "3",
}

// 加入資格
export enum JoinCapacity {
  "ア" = "ア",
  "イ" = "イ",
  "ウ" = "ウ",
}

// 経営者種別（契約申込）
export enum CorpTypeList3 {
  "社会福祉法人" = "01",
  "学校法人" = "08",
}

// 照会画面への反映コード
export enum InquiryCode {
  "契約者" = "1",
  "施設" = "2",
  "職員" = "3",
  "掛金" = "4",
}

//添付書類登録状態
export enum FormStatus {
  "不要" = "0",
  "登録済" = "1",
  "後で登録" = "9",
}

// 公費助成対象コード
export const TransitionalCode: any = {
  "0": "",
  "1": "★", // H18年制度改正前の加入者
  "2": "◆", // H28年制度改正前の加入者
  "3": "☆", // 施設転換前の加入者
};
